module.exports = __webpack_public_path__ + "static/media/progman_42.18bddff1.ico";